import { getterTypes, routesNames } from '@/core/constants'
import infoCabecalho from '@/core/store/default/infoCabecalho'
import VigenciaFilter from '@/views/filters/vigencia-filter'

const SEM_PROCESSO = 'Sem Processo'

const montaInformacoes = (info) => {
	return [
		new infoCabecalho('Nº Processo', { texto: info.processo ? info.processo.numero : SEM_PROCESSO }, 'processo'),
		new infoCabecalho('Nº Ata', { texto: info.numero }, 'numero', true),
		new infoCabecalho(
			'Órgão',
			{ texto: info.unidadeOrganizacional ? info.unidadeOrganizacional.sigla : SEM_PROCESSO },
			'orgao',
		),
		new infoCabecalho('Descrição', { texto: info.descricao }, 'descricao'),
		new infoCabecalho('Vigência', { texto: VigenciaFilter(info.fimValidade) }, 'fimValidade'),
	]
}

function montaAbas() {
	return [
		{
			titulo: 'Gestão da Ata',
			rota: { name: routesNames.ATA.ATA_ACESSAR_VIEW },
			permissao: null,
		},
	]
}

export default {
	[getterTypes.ATA.GET_INFORMACOES_ATA]: (state) => state.informacoesAta,
	[getterTypes.ATA.ATA_ACESSAR_VIEW]: () => montaAbas(),
	[getterTypes.ATA.GET_ATA_PARA_CABECALHO]: (state) => montaInformacoes(state.informacoesAta),
}
